<template>
  <v-form ref="form" v-model="valid" class="campaign-fields elevation-2">
    <UCardHeader
      v-model="localCampaign.name"
      :rules="headerRules"
      placeholder="Enter a campaign name"
      action="edit"
    />
    <div class="campaign-fields__body">
      <div class="campaign-fields__links">
        <v-textarea
          :rules="linkRules"
          v-model="localCampaign.links"
          height="100%"
          label="Links"
          no-resize
          rows="2"
          hint="Add one or more links separated on new lines"
          validate-on-blur
          color="secondary"
        />
      </div>
      <div class="campaign-fields__field-rows">
        <CampaignFieldsCardRow
          v-for="field in fieldsNotNull"
          :key="field.id"
          v-bind="field"
          :value="fieldValue(field.id)"
          @updateFieldValue="updateFieldValue"
        />
      </div>
    </div>
    <v-checkbox
      :label="'Encode parameters for app tracking'"
      :input-value="campaign.url_encoded"
      color="secondary"
      class="my-0 flex-shrink-1 flex-shrink"
      hide-details
      @change="toggleUrlEncoded"
      @click.native.stop
    />
    <div class="url-encoded-tip" v-if="localCampaign.url_encoded">
      Paste the following value into the link section for the "Mein E.ON" app in case of an app install campaign: https://play.google.com/store/apps/details?id=de.ones.eon.csc&referrer=
    </div>
    <div class="campaign-fields__footer">
      <UDialog
        :show="dialogDeleteCampaign"
        :actions="dialogDeleteCampaignActions"
        title="Delete Campaign"
        @closeDialog="dialogDeleteCampaign = false"
        @deleteCampaign="deleteCampaign"
      >
        <div slot="body">
          Are you sure you want to delete the campaign
          <strong>{{ localCampaign.name }}</strong
          >? This action cannot be undone.
        </div>
      </UDialog>
      <v-btn
        v-if="campaign.id"
        color="primary"
        flat
        data-tid="delete-button"
        @click="dialogDeleteCampaign = true"
        >Delete</v-btn
      >
      <v-btn color="primary" data-tid="cancel-button" flat @click="cancel"
        >Cancel</v-btn
      >
      <v-btn
        color="primary"
        data-tid="save-button"
        @click="formValid() && save(localCampaign)"
        >Save</v-btn
      >
    </div>
  </v-form>
</template>

<script>
import CampaignFieldsCardRow from "@/components/CampaignFieldsCardRow";
import UCardHeader from "@/components/UCardHeader";
import UDialog from "@/components/UDialog";
import { cloneDeep } from "lodash";

export default {
  components: {
    UCardHeader,
    UDialog,
    CampaignFieldsCardRow,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    save: {
      type: Function,
      required: true,
    },
    deleteCampaign: {
      type: Function,
      required: true,
    },
    cancel: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      localCampaign: cloneDeep(this.campaign),
      dialogDeleteCampaign: false,
      headerRules: [(value) => !!value || "Pick a name for your campaign"],
      valid: true,
      linkRules: [
        (value) => !!value || "Add one or more links separated on new lines",
      ],
    };
  },
  computed: {
    dialogDeleteCampaignActions() {
      return [
        {
          id: "delete-button",
          label: "Delete",
          button_color: "primary",
          action_name: "deleteCampaign",
          action_value1: this.campaign.id,
        },
      ];
    },
    fieldsNotNull() {
      return this.fields.filter(field => field != null);
    },
  },
  methods: {
    fieldValue(id) {
      const field_values = this.localCampaign.field_values;
      return field_values && field_values[id];
    },
    updateFieldValue(key, value, value2) {
      this.localCampaign.field_values[key] = value;
      if (value2) {
        this.localCampaign.field_values[`${key}_2`] = value2;
      } else {
        delete this.localCampaign.field_values[`${key}_2`];
      }
    },
    formValid() {
      return this.$refs.form.validate();
    },
    toggleUrlEncoded(event) {
      this.localCampaign.url_encoded = event;
    },
  },
};
</script>

<style lang="scss">
.url-encoded-tip {
  font-size: 12px;
  color: #777;
}
.campaign-fields {
  @include card();

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-gap: 5px;

  .campaign-fields__body {
    display: inline-grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-template-rows: 1fr;
    grid-gap: 25px;
  }
  .campaign-fields__links {
    height: 100%;
    display: flex;
    padding-bottom: 20px;

    .v-input.v-textarea {
      height: calc(100% - 4px);
      .v-input__control {
        align-self: stretch;
        flex-direction: row;
        .v-text-field__slot {
          height: 100%;
        }
      }
    }
  }
  .campaign-fields__footer {
    text-align: right;
    .v-btn {
      margin-right: 0;
    }
  }
}
</style>
